import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd-mobile";
import { useTranslation } from "react-i18next";
import filterTypeEnum from "../../../../enumerations/filterTypeEnum";
import FilterTypeDateTimeRange from "../../../FilterTypeDateTimeRange";
import FilterTypeDropdownSelect from "../../../FilterTypeDropdownSelect";
import FilterTypeInput from "../../../FilterTypeInput";
import FilterTypeSelect from "../../../FilterTypeSelect";
import styles from "./style.module.scss";
import "./style.scss";
const FilterDrawer = ({
  filters = [],
  localFilterValue = {},
  setLocalFilterValue = () => { },
  onReset = () => { },
  onSubmitSearch = () => { },
  setDependency = () => { },
  dependency = {},
  apiValue = {},
}) => {
  const { t } = useTranslation();

  const onHandleSumbit = () => {
    onSubmitSearch();
  };

  const onHandleReset = () => {
    onReset();
  };

  const setInputValue = (e, filter) => {
    setLocalFilterValue((prevState) => {
      return {
        ...prevState,
        [filter.data_index]: e,
      };
    });
  };

  const setSelectValue = (value, filter) => {
    const _dependency = Object.keys(dependency).find(
      (key) => key === filter.data_index
    );
    if (_dependency) {
      setDependency((prevState) => {
        return {
          ...prevState,
          [_dependency]: value,
        };
      });
    }

    setLocalFilterValue((prevState) => {
      return {
        ...prevState,
        [filter.data_index]: value,
      };
    });
  };

  const setDateTimeValue = (value, filter, type) => {
    switch (type) {
      case "start":
        setLocalFilterValue((prevState) => {
          return {
            ...prevState,
            [filter.data_index[0]]: value,
          };
        });
        break;
      case "end":
        setLocalFilterValue((prevState) => {
          return {
            ...prevState,
            [filter.data_index[1]]: value,
          };
        });
        break;
      default:
        break;
    }
  };

  const renderFilter = (filter) => {
    switch (filter.type) {
      case filterTypeEnum.INPUT:
        return (
          <FilterTypeInput
            title={t(filter.title)}
            placeholder={t("mobile.normal.pleaseInput", {
              name: t(filter.title),
            })}
            value={localFilterValue[filter.data_index]}
            setValue={(e) => setInputValue(e, filter)}
          />
        );
      case filterTypeEnum.DATE_TIME_RANGE:
        return (
          <FilterTypeDateTimeRange
            title={t(filter.title)}
            startDate={localFilterValue[filter.data_index[0]]}
            endDate={localFilterValue[filter.data_index[1]]}
            setStartDateValue={(value) =>
              setDateTimeValue(value, filter, "start")
            }
            setEndDateValue={(value) => setDateTimeValue(value, filter, "end")}
            precision={filter.precision}
            maxMonthInterval={filter.maxMonthInterval}
          />
        );
      case filterTypeEnum.SELECT:
        if (filter.data_type === "api") {
          filter = {
            ...filter,
            value_enum: apiValue[filter.data_index].value_enum,
            default_value: apiValue[filter.data_index].default_value || null,
          };
        }
        return (
          <FilterTypeSelect
            required={filter.required}
            columns={filter.columns || 3}
            title={t(filter.title)}
            options={filter.value_enum.map((val) => {
              return {
                ...val,
                label: val.is_translation ? t(val.label) : val.label,
              };
            })}
            value={
              localFilterValue[filter.data_index] !== null
                ? [localFilterValue[filter.data_index]]
                : []
            }
            setValue={(value) => setSelectValue(value, filter)}
          />
        );
      case filterTypeEnum.DROPDOWN_SELECT:
        if (filter.data_type === "api") {
          filter = {
            ...filter,
            value_enum: apiValue[filter.data_index].value_enum,
            default_value: apiValue[filter.data_index].default_value || null,
          };
        }
        return (
          <FilterTypeDropdownSelect
            required={filter.required}
            columns={filter.columns || 3}
            title={t(filter.title)}
            options={filter.value_enum.map((val) => {
              return {
                ...val,
                label: val.is_translation ? t(val.label) : val.label,
              };
            })}
            value={
              localFilterValue[filter.data_index] !== null
                ? [localFilterValue[filter.data_index]]
                : []
            }
            setValue={(value) => setSelectValue(value, filter)}
          />
        );
      default:
        return (
          <div>
            invalid filter type, filter must be type of Input, DateTimeRange, or
            Select
          </div>
        );
    }
  };
  return (
    <div className={`${styles.container}`}>
      <div className={styles.scroll}>
        {filters.map((filter) => (
          <div
            key={filter.data_index}
            className={`${styles.filterDrawerItemContainer}`}
          >
            {renderFilter(filter)}
          </div>
        ))}
      </div>

      <div className={styles.buttonContainer}>
        <Button className={styles.reset} onClick={onReset}>
          {t("mobile.filter.clearButton")}
        </Button>
        <Button className={styles.submit} onClick={onHandleSumbit}>
          {t("mobile.filter.submitButton")}
          <RightOutlined />
        </Button>
      </div>
    </div>
  );
};
export default FilterDrawer;
